import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Nexus } from '@tomandco/nexus-api-types';
import { DfApiConfigService } from './df-api-config.service';

export const apiConfigResolver: ResolveFn<Nexus.Api.General.AppData.Response> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    return inject(DfApiConfigService).loadApiConfig();
};
